import {
  LOAD_USER_STATUS,
  USER_DATA_LOADED,
  APP_MIGRATION_ENABLED,
  SHOW_APP_MIGRATION,
  NON_HARD_MIGRATED_SME_FLOW,
  SET_USER_TIER,
  TOGGLE_IS_UTILITY_API_CALLED,
  SET_BUSINESS_PAYMENT_METHODS
} from '../../action-contants';
import {
  isUserAuthenticated,
  isUserAuthenticating,
  logoutRequest
} from '../authentication/authentication-action';
import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { NOT_ALLOWED_USER_STATUS, SHOW_FEE_DIFFERENCE } from '../../../utils/constants';
import { makeApiCall, getSourceCurrencies } from '../common/common-action';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { getInstapointsLogic } from '../user-state/user-state-action';
import { store } from '../../../store';
import { isIndividual } from '../../../utils/library';
import { isFlagEnabled } from '../flagsmith/flagsmith-main';

function load(data) {
  return {
    type: LOAD_USER_STATUS,
    data
  };
}

export const remitterPersonalInfoLoaded = (data) => {
  return {
    type: USER_DATA_LOADED,
    data
  };
};

export function remitterPersonalInfo() {
  return async (dispatch) => {
    dispatch(remitterPersonalInfoLoaded(false));
    try {
      const response = await makeApiCall({
        url: `${API_URL}/remitter-personal-info`,
        method: 'get',
        withCredentials: true
      });
      const loadData = { ...response.data.data };
      if (loadData) {
        const reduxStore = store.getState();
        const instaPointsLogicData = get(
          reduxStore,
          'rootReducer.userDataReducer.instaPointsLogicData',
          null
        );
        if (!instaPointsLogicData) {
          await dispatch(getInstapointsLogic());
        }
        const source_currency = await getSourceCurrencies(loadData.country_code);
        const sourceCurrencyList = get(source_currency, 'data.data', []);
        if (!isEmpty(sourceCurrencyList)) {
          loadData.source_currency = sourceCurrencyList[0].value;
          loadData.sourceCurrencyList = sourceCurrencyList;
        }
      }
      if (NOT_ALLOWED_USER_STATUS.includes(response.data.data.status)) {
        await dispatch(logoutRequest());
        dispatch(isUserAuthenticated(false));
        dispatch(isUserAuthenticating(false));
      } else {
        dispatch(load(loadData));
        dispatch(remitterPersonalInfoLoaded(true));
        dispatch(isUserAuthenticated(true));
        dispatch(isUserAuthenticating(false));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      dispatch(isUserAuthenticated(false));
      dispatch(isUserAuthenticating(false));
    }
  };
}

export const setAppMigrationStatus = (data) => {
  const reduxStore = store.getState();
  const country_code = get(reduxStore, 'rootReducer.userStatusReducer.country_code', null);
  const parsedData = JSON.parse(data.data);
  return {
    type: APP_MIGRATION_ENABLED,
    data:
      data.isFeatureEnabled && (parsedData?.applicableCountries?.includes(country_code) || false)
  };
};

export const isAppMigrationEnabledContent = () => {
  return async (dispatch) => {
    if (!isIndividual()) {
      return;
    }
    const reduxStore = store.getState();
    let isAppMigrationEnabled = get(
      reduxStore,
      'rootReducer.userStatusReducer.isAppMigrationEnabled',
      null
    );
    if (typeof isAppMigrationEnabled !== 'boolean') {
      isAppMigrationEnabled = isFlagEnabled(SHOW_FEE_DIFFERENCE);
    }

    const feeDifference =
      get(
        reduxStore,
        'rootReducer.transactionReducer.transactionDetails.transaction_config.app_fee_difference',
        0
      ) > 0;
    await dispatch(setShowAppMigration(isAppMigrationEnabled && feeDifference));
    return;
  };
};

const setShowAppMigration = (data) => {
  return {
    type: SHOW_APP_MIGRATION,
    data
  };
};

export const setNonHardMigratedSMEFlag = (data) => {
  return {
    type: NON_HARD_MIGRATED_SME_FLOW,
    data
  };
};

const setUserTierAction = (data) => {
  return {
    type: SET_USER_TIER,
    data
  };
};

const setBusinessPaymentMethod = (data) => {
  return {
    type: SET_BUSINESS_PAYMENT_METHODS,
    data
  };
};

export const toggleIsUtilityApiCalledAction = (flag) => {
  return {
    type: TOGGLE_IS_UTILITY_API_CALLED,
    data: flag
  };
};

export const toggleIsUtilityApiCalled = (flag) => {
  return (dispatch) => {
    dispatch(toggleIsUtilityApiCalledAction(flag));
  };
};

export const getUserTier = () => {
  return async (dispatch, getStore) => {
    const {
      rootReducer: {
        userStatusReducer: { isUtilityApiCalled },
        userSessionReducer: { is_user_authenticated }
      }
    } = getStore();
    if (!isUtilityApiCalled && is_user_authenticated) {
      try {
        const response = await makeApiCall({
          url: `${API_URL}/utility`,
          method: 'get',
          withCredentials: true
        });
        dispatch(toggleIsUtilityApiCalledAction(true));
        dispatch(setUserTierAction(response.data.data.display_computation_comparison));
        dispatch(setBusinessPaymentMethod(response?.data?.data?.promote_payment_methods));
      } catch (error) {
        handleError(error);
      }
    }
  };
};
